"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MrButterLooking = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("../SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.stroke, stroke = _c === void 0 ? 'black' : _c, size = _a.size, rest = __rest(_a, ["fill", "stroke", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: [jsx_runtime_1.jsx("rect", { x: "0.5", y: "0.5", width: "23", height: "23", rx: "5.5", fill: fill, stroke: stroke, strokeWidth: "1", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M8.50049 16.0001H18.5005", stroke: stroke, strokeWidth: "1", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M9.07308 8.63637C9.94542 7.93708 10.923 7.72658 12.0059 8.00489", stroke: stroke, strokeWidth: "1", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M18.7224 6.94983C18.5891 6.6165 18.1624 5.94983 17.5224 5.94983C16.8824 5.94983 15.7224 7.00003 14.7224 7.50003", stroke: stroke, strokeWidth: "1", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "11.2495", cy: "10.9496", r: "1", fill: "black" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "17.2495", cy: "10.9496", r: "1", fill: "black" }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.stroke, stroke = _c === void 0 ? 'black' : _c, size = _a.size, rest = __rest(_a, ["fill", "stroke", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: [jsx_runtime_1.jsx("rect", { x: "0.75", y: "0.75", width: "30.5", height: "30.5", rx: "7.25", fill: fill, stroke: stroke, strokeWidth: "1.5", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M11.334 21.3335H24.6673", stroke: stroke, strokeWidth: "1.5", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M12.0974 11.5152C13.2606 10.5828 14.564 10.3021 16.0078 10.6732", stroke: stroke, strokeWidth: "1.5", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M24.9632 9.26644C24.7854 8.82199 24.2165 7.93311 23.3632 7.93311C22.5099 7.93311 20.9632 9.33337 19.6299 10", stroke: stroke, strokeWidth: "1.5", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "14.9993", cy: "14.5994", r: "1.33333", fill: "black" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "22.9993", cy: "14.5994", r: "1.33333", fill: "black" }, void 0)] }), void 0));
};
var MrButterLooking = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.MrButterLooking = MrButterLooking;
//# sourceMappingURL=MrButterLooking.js.map